import React, { FC, Fragment } from "react";
import "devextreme/data/odata/store";
import {
  AppointmentDetail,
  CompanyNotesCard,
  OrderTotals,
} from "components/load-confirmation";
import { AppointmentDetails, Stop, StopDetailsResponse } from "types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-duotone-svg-icons";

type Props = {
  stopDetails: StopDetailsResponse;
  loadNumber: string;
  stop: any;
};

const StopDetail: FC<Props> = ({ stopDetails, loadNumber, stop }) => {
  const appointmentDetails: AppointmentDetails = {
    id: `${stopDetails.odsStopEventId ?? ""}`,
    customerOrAddressName: stopDetails.customerOrAddressName ?? "",
    addressOne: stopDetails.addressOne ?? "",
    city: stopDetails.city ?? "",
    state: stopDetails.state ?? "",
    postalCode: stopDetails.postalCode ?? "",
    scheduledStartDate: stopDetails.scheduledStartDate ?? "",
    appointmentTimeZone: stopDetails.appointmentTimeZone ?? "",
    miles: stopDetails.miles ?? 0,
    confirmationNumber: "",
    weightTotal: `${stopDetails.weightTotal ?? ""}`,
    cubeTotal: `${stopDetails.cubeTotal ?? ""}`,
    piecesTotal: `${stopDetails.piecesTotal ?? ""}`,
    lineItemsTotal: `${stopDetails.lineItemsTotal ?? ""}`,
    displayStopDetails: stopDetails.displayStopDetails,
  };

  return stopDetails ? (
    <Fragment>
      <AppointmentDetail
        cube={`${stopDetails.cubeTotal ?? ""}`}
        stops={[] as Stop[]}
        pieceCount={`${stopDetails.piecesTotal ?? ""}`}
        lineItems={`${stopDetails.lineItemsTotal ?? ""}`}
        weight={`${stopDetails.weightTotal ?? ""}`}
        loadNumber={loadNumber}
        appointmentDetails={appointmentDetails}
      />

      {stopDetails.orders.map((order, index) => (
          <OrderTotals
              // TODO: Find out about this
              confirmationNumber={""}
              orderNumber={order.orderNumber}
              temperature={order.temperature}
              key={`${order.orderNumber}-${index}`}
              weight={`${order.weight ?? ""}`}
              cube={`${order.cube ?? ""}`}
              pieceCount={`${order.pieces ?? ""}`}
              items={`${order.lineItems ?? ""}`}
          />
      ))}
      {stop ? (
          <CompanyNotesCard stop={stop}/>
      ) : (
          <div className="center-icon center red-component fas fa-spinner fa-spin" style={{marginTop: '25px'}}>
            <FontAwesomeIcon icon={faSpinner} size={"3x"}/>
          </div>
      )}
    </Fragment>
  ) : (
      <Fragment/>
  );
};

export default StopDetail;
